export const env = {
  uid: "0", // 用户 uid, 用于日志上下文或登录校验
};

/** 游戏 id，来自 crawler/trend/manifest.json */
export const GAME_ID = 5485;

/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const TOOL_ID = "o85p2vmi";

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType */
export const TOOL_TYPE = 1;
